export const UPLOAD_START   = 'UPLOAD_START';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
export const UPLOAD_FAIL    = 'UPLOAD_FAIL';